module.exports = "pegasus/assets/blocks/column-7-theme4.png";